import { render, staticRenderFns } from "./VaultOfDarknessDescript.vue?vue&type=template&id=84f8fc1c"
import script from "./VaultOfDarknessDescript.vue?vue&type=script&setup=true&lang=js"
export * from "./VaultOfDarknessDescript.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports